/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useLocation } from "react-router-dom";

import { BOTTOM_NAV_DESTINATION_IDS } from "./useBottomNavItems";
import { useNavDestinations } from "./useNavDestinations";

const normalise = (path: string): string =>
  path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;

/**
 * A first-level route is a mobile bottom-nav base tab landing page (Home, Shop,
 * Agreements, Partners, More). Anything deeper — including section landing pages
 * that aren't base tabs, such as Orders, Seed, Quotes and Activities — is a
 * second-level route. The mobile header shows the logo on first-level routes and
 * a back button on deeper ones.
 */
export const useIsFirstLevelRoute = (): boolean => {
  const { pathname } = useLocation();
  const destinations = useNavDestinations();

  const currentPath = normalise(pathname);
  return BOTTOM_NAV_DESTINATION_IDS.some((id) => normalise(destinations[id].to) === currentPath);
};
